﻿import { ready } from "@nephele/dom-utils";

ready(() => {
  const banner = document.querySelector(".maintenance-banner");

  if (!banner) return;

  banner.addEventListener(
    "transitionend",
    (event) => {
      // remove the banner when the opacity transition ends
      if (event.propertyName === "opacity") {
        banner.remove();
      }
    },
    { once: true }
  );

  banner.querySelector(".dismiss-link")?.addEventListener("click", () => {
    banner.classList.add("hidden");
  });
});
